var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import * as React from 'react';

function replaceIn(a, index, newValue) {
  var b = a.slice();
  b.splice(index, 1, newValue);
  return b;
}

var resolvedMagically = {};

var isResolved = function isResolved(a) {
  return a !== undefined;
};

var Catcher = function (_super) {
  __extends(Catcher, _super);

  function Catcher() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      caught: 0,
      pending: [],
      resolved: [],
      rejected: [],
      throw: undefined,
      catched: undefined
    };
    return _this;
  }

  Catcher.prototype.componentDidUpdate = function (_, oldState) {
    if (oldState.throw !== this.state.throw) {
      throw this.state.throw;
    }

    if (oldState.catched !== this.state.catched) {
      if (this.props.onCatch) {
        this.props.onCatch(this.state.catched);
      }
    }
  };

  Catcher.prototype.componentDidCatch = function (error) {
    var _this = this;

    if ('then' in error) {
      this.setState({
        catched: error
      });
      this.setState(function (state) {
        var id = state.caught;
        error.then(function (value) {
          return _this.setState(function (_a) {
            var resolved = _a.resolved,
                pending = _a.pending;
            return {
              resolved: replaceIn(resolved, id, value === undefined ? resolvedMagically : value),
              pending: replaceIn(pending, id, false)
            };
          });
        }).catch(function () {
          return _this.setState(function (_a) {
            var rejected = _a.rejected,
                pending = _a.pending;
            return {
              rejected: replaceIn(rejected, id, true),
              pending: replaceIn(pending, id, false)
            };
          });
        });
        return {
          caught: id + 1,
          pending: state.pending.concat([true]),
          resolved: state.resolved.concat([undefined]),
          rejected: state.rejected.concat([false])
        };
      });
    } else {
      this.setState({
        throw: error
      });
    }
  };

  Catcher.prototype.render = function () {
    var _a = this.state,
        caught = _a.caught,
        pending = _a.pending,
        rejected = _a.rejected,
        resolved = _a.resolved;
    return this.props.children({
      caught: caught,
      pending: pending.some(Boolean),
      rejected: rejected.some(Boolean),
      resolved: resolved.some(isResolved),
      results: resolved
    });
  };

  return Catcher;
}(React.Component);

export { Catcher };